import { render, staticRenderFns } from "./GaleriaImagemProductComponent.vue?vue&type=template&id=0abffaac&scoped=true&"
import script from "./GaleriaImagemProductComponent.vue?vue&type=script&lang=js&"
export * from "./GaleriaImagemProductComponent.vue?vue&type=script&lang=js&"
import style0 from "./GaleriaImagemProductComponent.vue?vue&type=style&index=0&id=0abffaac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0abffaac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VContainer,VDivider,VFlex,VIcon,VImg,VLayout})
